import axios from '@axios';

const base = '/api/v1/analyst-users';

export default {
  login(username, password) {
    return axios.post(`${base}/tokens`, { username, password });
  },
  getUser() {
    return axios.get(`${base}/user`);
  },
  getPrisonGroups() {
    return axios.get(`${base}/getPrisonGroups`);
  },
  getPrisonsInGroup(groupId) {
    return axios.get(`${base}/getPrisonsInGroup/${groupId}`);
  },
};
